<div class="preview-panel">
  <div class="preview-filter">
    <label for="previewRoleFilter">View fields for</label>
    <select id="previewRoleFilter" class="rail-select" [ngModel]="previewFilter" (ngModelChange)="previewFilterChange.emit($event)">
      <option value="all">All recipients</option>
      @for (actor of actors; track actor.id) {
        <option [value]="actor.id">{{ actor.label }}</option>
      }
    </select>
  </div>

  <section class="preview-card">
    <h3>Document summary</h3>
    @if (previewMeta.fileLabel) {
      <div class="preview-row">
        <span class="preview-row__label">Uploaded file</span>
        <span class="preview-row__value">{{ previewMeta.fileLabel }}</span>
      </div>
    }
    <div class="preview-row">
      <span class="preview-row__label">{{ previewMeta.pageCountLabel || 'Pages' }}</span>
      <span class="preview-row__value">{{ pageCount }}</span>
    </div>
    <div class="preview-row">
      <span class="preview-row__label">Total fields</span>
      <span class="preview-row__value">{{ totalFields }}</span>
    </div>
  </section>

  <section class="preview-card">
    <h3>Recipient details</h3>
    @for (actor of actors; track actor.id) {
      <div class="recipient-row">
        <span class="dot" [style.background]="actor.color"></span>
        <span>{{ actor.label }}</span>
        <span>{{ actor.fieldCount }} field(s)</span>
      </div>
    }
  </section>

  <section class="preview-card">
    <h3>Document message</h3>
    <label for="previewDocTitle">Title</label>
    <input
      class="rail-input"
      id="previewDocTitle"
      type="text"
      [ngModel]="previewMeta.title || ''"
      [readonly]="previewMeta.canEditTitle === false"
      (ngModelChange)="previewMetaChange.emit({ title: $event })"
    />
    <label for="previewDocMessage">Message</label>
    <textarea
      class="rail-textarea"
      id="previewDocMessage"
      rows="3"
      [ngModel]="previewMeta.message || ''"
      [readonly]="previewMeta.canEditMessage === false"
      (ngModelChange)="previewMetaChange.emit({ message: $event })"
    ></textarea>
  </section>
</div>
